/**
 * DO NOT DELETE
 * THESE FUNCTIONS ARE USED IN WEBPACK CONFIG
 * htmlwebplugin META DATA
 * and settags.js
 * type definitions are in src/vendor/meta-data.d.js
 */

/** @returns {Record<string, [string, string][]>} */
const getMetaLookupTable = (): Record<string, [string, string][]> => ({
  title: [
    ['name', 'title'],
    ['property', 'og:title'],
    ['name', 'twitter:title'],
  ],
  description: [
    ['name', 'description'],
    ['name', 'twitter:description'],
    ['property', 'og:description'],
  ],
  viewport: [['name', 'viewport']],
  siteName: [['property', 'og:site_name']],
  url: [['property', 'og:url']],
  image: [
    ['property', 'og:image'],
    ['name', 'twitter:image'],
  ],
  theme: [['property', 'og:theme']],
  themeColor: [
    ['name', 'theme-color'],
    ['name', 'apple-mobile-web-app-status-bar-style'],
  ],
  imageWidth: [['property', 'og:image:width']],
  imageHeight: [['property', 'og:image:height']],
  type: [['property', 'og:type']],
  facebookAppId: [['property', 'fb:app_id']],
  twitterCard: [['name', 'twitter:card']],
  twitterSite: [['name', 'twitter:site']],
  twitterCreator: [['name', 'twitter:creator']],
  keywords: [['name', 'keywords']],
  author: [['name', 'author']],
  appleItunesApp: [['name', 'apple-itunes-app']],
  googlePlayApp: [['name', 'google-play-app']],
});

export const getTitle = () => 'MetService - Te Ratonga Tirorangi';
const getCardImage = () => 'https://www.metservice.com/public/favicons/ms-thumb.png';
const getDescription = () =>
  'New Zealand Town and City weather forecasts, maps, rain radar and current conditions. MetService is New Zealand’s national weather authority, providing accurate urban and rural forecasts across the country.';

/** @returns {Record<string, string>} */
export const defaultRawMetaData = () => ({
  title: getTitle(),
  description: getDescription(),
  themeColor: '#243463',
  viewport: 'width=device-width, initial-scale=1',
  url: getCardImage(),
  image: getCardImage(),
  type: 'website',
  twitterCard: 'summary_large_image',
  twitterSite: '@metservicenz',
});

/** @typedef {{property: 'string'} | {name: 'string'}} MetaDataConfig */

/**
 * Converts meta data object is to a meta data config array that webpack html plugin can use
 * https://github.com/jantimon/html-webpack-plugin#meta-tags
 * @param {Record<string, string>} populatedMetaData
 * @returns {Record<string, {MetaDataConfig & { content: string } }>}
 */
export function getMetaData(populatedMetaData: { [x: string]: any; }) {
  const result = Object.keys(populatedMetaData).reduce((parentAcc, key) => {
    const lookupItem = getMetaLookupTable()[key];
    if (lookupItem) {
      const config = lookupItem.reduce((childAcc: any, config: [any, any]) => {
        const [name, property] = config;
        const newVal = {
          [property]: {
            [name]: property,
            content: populatedMetaData[key],
          },
        };
        return { ...childAcc, ...newVal };
      }, {});
      return { ...parentAcc, ...config };
    }
    return parentAcc;
  }, {});
  return result;
}
